export default __webpack_public_path__ + "static/media/mona-loading-default.026de01c.gif";